import limitModeTypeCheckers from '../../components/V5GadgetForm/limitModeTypeCheckers';

const buildGroupBy = (
  def: V5ChartDefinition,
  isIgnoringLimit?: boolean,
): V5GroupBy | undefined => {
  const { dimensionA, dimensionB, series } = def;
  const sortBySeries = series.find((s) => s.sortByMetricId);
  const defaultSortMetricId = def.grouping?.defaultSort?.metricId;
  const sortByMetricId =
    defaultSortMetricId ??
    sortBySeries?.metricId ??
    def.grouping?.defaultSort?.metricId;
  const sortDirection: SortBy | undefined =
    def.groupBySortBy ?? def.grouping?.defaultSort?.direction;

  if (
    dimensionA &&
    (dimensionA.fieldType === 'text' || dimensionA.fieldType === 'boolean')
  ) {
    const isExcludeTopN = limitModeTypeCheckers.isExcludeTopN(
      def.groupByLimitMode,
    );
    if (sortByMetricId) {
      return {
        field: dimensionA.field,
        type: dimensionA.fieldType,
        sort: isExcludeTopN ? undefined : sortDirection,
        limit: isIgnoringLimit ? undefined : def.groupByLimit,
        sortByMetric: sortByMetricId,
      };
    }

    return {
      field: dimensionA.field,
      type: dimensionA.fieldType,
      sort: isExcludeTopN ? undefined : sortDirection,
      limit: isIgnoringLimit ? undefined : def.groupByLimit,
    };
  }

  if (dimensionB && dimensionB.fieldType === 'text') {
    return {
      field: dimensionB.field,
      type: dimensionB.fieldType,
      sort: undefined,
      limit: isIgnoringLimit ? undefined : def.groupByLimit,
      sortByMetric: sortByMetricId,
    };
  }
  return undefined;
};

export default buildGroupBy;
